import React from "react";
import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import ImageCropUploader from "../imageCrop";
// import { ReactComponent as Close } from "../../assets/images/icons/close.svg";

export function ImageCropModal(props) {
  console.log("props", props);
  const { width, height, images, getCroppedImages } = props;
  console.log("getCroppedImagesmodl", typeof getCroppedImages);
  return (
    <>
      <Transition show={props.show} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={props.onClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="p-5 w-full max-w-2xl bg-white dark:bg-[#121212] rounded-2xl border relative shadow-xl sm:p-8 mx-auto">
                  {/* <div className=" sm:block absolute top-1 sm:top-3 right-5 pt-4 pr-4">
                    <button
                      type="button"
                      className="bg-[#ffeae5] dark:bg-[#CE2600] rounded-md sm:p-3 p-2"
                      onClick={props.onClose}
                    >
                      <span className="sr-only">Close</span>
                      <Close className="w-3 h-3 sm:w-4 sm:h-4 white-icon" />
                    </button>
                  </div> */}
                  <div className="sm:flex sm:justify-center ">
                    <div className="text-center">
                      <Dialog.Title
                        as="h3"
                        className="text-xl text-center font-bold text-black dark:text-white"
                      >
                        Crop and Resize
                      </Dialog.Title>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-4 text-left">
                    <ImageCropUploader
                      width={width}
                      height={height}
                      images={images}
                      onClose={props.onClose}
                      getCroppedImages={getCroppedImages}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
